import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-info">
                <p><a href="https://api.whatsapp.com/send?phone=5215548458860&amp;text=Hola😄">WhatsApp</a></p>
                <p><a href="mailto:mfelicitasernst@gmail.com">Email</a></p>                    
                <p><a href="https://instagram.com/feliernst">Instagram</a></p>
                <br />
                <p>2025 Felicitas Ernst</p>
                <p>All Rights Reserved</p>
            </div>
            <div className="footer-links">
                <p><a href="/photography">Photography</a></p>
                <p><a href="/adds-or-clips">Video</a></p>
            </div>
        </footer>
    );
};

export default Footer;
